const WORDS = ["Comics & Vignettes", "Grungy Street Graphics", "Concept Art", "Digital Ink", "After-Hours Archive", "Panels & Paint"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center font-display font-black uppercase text-3xl sm:text-5xl px-6 whitespace-nowrap">
        {w}
        <span className="ml-12 font-mono text-base sm:text-xl">///</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee" className="relative z-10 -my-2 overflow-hidden bg-[#F5A524] text-black py-5 -rotate-[1.5deg] scale-[1.03] border-y-2 border-black">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
